/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component — thin session-backed shell showing a back link / login CTA
 *   extends:   Component (@glimmer/component)
 *   template:  back-link.hbs
 *   args:      @backFn
 *   uses:      session service
 *   siblings:  contact-item.js, product-item.js, invoice-item.js (same thin-shell pattern)
 *   tests:     list-components-test.js
 *
 * Shows a login call-to-action for an anonymous visitor, or the signed-in
 * visitor's back link wired to @backFn.
 */
import Component from '@glimmer/component';
import { service } from '@ember/service';

export default class BackLinkComponent extends Component {
  @service session;
}
